// extracted by mini-css-extract-plugin
export default {"body":"JsonAutoComplete_body__D+X6N","tip":"JsonAutoComplete_tip__S4lFH"};